import "./Spinner.scss";

import React from "react";

export const Spinner = () => (
  <div className="lds-default m-auto d-flex justify-content-center">
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
);
export default Spinner;
